<script>
export default {
  name: 'TherapistTable',
  props: ['data'],
}
</script>

<template>
  <div class="invoice-rd">
    <table>
      <colgroup>
        <col style="width: auto;">
        <col class="invoice-rd__col-group">
        <col class="invoice-rd__col-group">
      </colgroup>
      <thead>
        <tr>
          <th class="text-14 fw-700 text-left">{{'Name' | translate}}</th>
          <th class="invoice-rd__content text-14 fw-700">{{'Phone Number' | translate}}</th>
          <th class="invoice-rd__content text-14 fw-700">{{'Email' | translate}}</th>
          <th class="invoice-rd__content text-14 fw-700">{{'Address' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p class="text-14 fw-500 color-default">{{data.full_name}}</p>
          </td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">
              {{data.phone || '-'}}
            </p>
          </td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">
              {{data.email || '-'}}
            </p>
          </td>
          <td>
            <p class="invoice-rd__content text-14 fw-500 color-default">
              {{data.address || '-'}}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="less" scoped>
@import "./../../less/redesign/vars";
.text-left {
  text-align: left;
}
.invoice-rd {
  border: 1px solid @grey-hover;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  & table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  & thead {
    background-color: @grey-hover;
  }
  & td, th {
    padding: 20px 24px;
  }
  & tbody tr, tfoot tr:not(:last-child) {
    border-bottom: 1px solid @grey-hover;
  }
  &__content {
    text-align: center;
  }
  &__col-group {
    width: 200px;
  }

  @media screen and (max-width: 670px) {
    .invoice-rd__col-group {
      width: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/tbooking-widget/TherapistTable.vue